import * as React from "react";
import { Card, Divider } from "antd";
import { CardTitle } from "../../../../components/antd/card/CardTitle";
import { CardContent } from "../../../../components/antd/card/CardContent";
import { CardCollapsibleContent } from "../../../../components/antd/card/CardCollapsibleContent";
import { useCpFormValue } from "../../../gvc/testNewForm/utils";
import { CpFormItem } from "../../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../../gvc/testNewForm/CpLabel";
import { CpErrorWarning } from "../../../gvc/testNewForm/CpErrorWarning";
import { CpSwitch } from "../../../gvc/testNewForm/CpSwitch";
import { CpDescription } from "../../../gvc/testNewForm/CpDescription";
import { CpArrayString } from "../../../gvc/testNewForm/CpArrayString";
import { CpInput } from "../../../gvc/testNewForm/CpInput";
import { CpInputNumber } from "../../../gvc/testNewForm/CpInputNumber";
import { CpErrorWarningArrayIcon } from "../../../gvc/testNewForm/CpErrorWarningArrayIcon";
import { CpKindSelect } from "../../../gvc/testNewForm/temp/CpKindSelect";

interface Props {}
export const IdentityCreateCloudaccessNGS: React.FC<Props> = ({}) => {
  const ngsLogoPath = `/resources/logos/ngsLogo.svg`;

  const isEnabled = useCpFormValue(`ngs.isEnabled`);

  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardTitle>
            <div className={`flex items-center`}>
              <img
                aria-label="NGS Cloud Access"
                style={{ width: "auto", height: 30 }}
                src={ngsLogoPath}
                className="self-center mr-2"
              />
              <span>NGS</span>
              <CpErrorWarningArrayIcon names={["ngs"]} />
            </div>
          </CardTitle>
          <CardContent>
            <CpFormItem>
              <div className="flex items-center gap-2">
                <CpLabel name={`ngs.isEnabled`}>Configure</CpLabel>
                <CpSwitch name={`ngs.isEnabled`} />
              </div>
              <CpErrorWarning name={`ngs.isEnabled`} />
            </CpFormItem>
            <CardCollapsibleContent collapsed={!isEnabled}>
              <CpFormItem>
                <CpLabel name="ngs.cloudAccount">NGS Cloud Account</CpLabel>
                <CpDescription>NGS cloud account is used to authenticate.</CpDescription>
                <CpKindSelect
                  kind="cloudaccount"
                  queries={[{ property: "provider", value: "ngs" }]}
                  name="ngs.cloudAccount"
                  optionValue="name"
                  style={{ width: 500 }}
                />
                <CpErrorWarning name="ngs.cloudAccount" />
              </CpFormItem>
              <Divider />
              <div style={{ maxWidth: 600 }}>
                <CpArrayString label="Pub Allow" name={`ngs.pub.allow`} />
              </div>
              <Divider />
              <div style={{ maxWidth: 600 }}>
                <CpArrayString label="Pub Deny" name={`ngs.pub.deny`} />
              </div>
              <Divider />
              <div style={{ maxWidth: 600 }}>
                <CpArrayString label="Sub Allow" name={`ngs.sub.allow`} />
              </div>
              <Divider />
              <div style={{ maxWidth: 600 }}>
                <CpArrayString label="Sub Deny" name={`ngs.sub.deny`} />
              </div>
              <Divider />
              <CpFormItem>
                <CpLabel name={`ngs.resp.max`}>Response Max</CpLabel>
                <CpDescription>Number of responses allowed on the replyTo subject, -1 means no limit</CpDescription>
                <CpInputNumber name={`ngs.resp.max`} />
                <CpErrorWarning name={`ngs.resp.max`} />
              </CpFormItem>
              <CpFormItem>
                <CpLabel name={`ngs.resp.ttl`}>Response TTL</CpLabel>
                <CpDescription>
                  <div>Deadline to send replies on the replyTo subject</div>
                  <div>[#ms(millis) | #s(econds) | m(inutes) | h(ours)]. -1 means no restriction</div>
                </CpDescription>
                <CpInput name={`ngs.resp.ttl`} style={{ width: 500 }} />
                <CpErrorWarning name={`ngs.resp.ttl`} />
              </CpFormItem>
              <CpFormItem>
                <CpLabel name={`ngs.subs`}>Subs</CpLabel>
                <CpDescription>Max number of subscriptions per connection, -1 mean unlimited</CpDescription>
                <CpInputNumber name={`ngs.subs`} />
                <CpErrorWarning name={`ngs.subs`} />
              </CpFormItem>
              <CpFormItem>
                <CpLabel name={`ngs.data`}>Data</CpLabel>
                <CpDescription>Max number of bytes a connection can send, -1 mean unlimited</CpDescription>
                <CpInputNumber name={`ngs.data`} addonAfter={`bytes`} />
                <CpErrorWarning name={`ngs.data`} />
              </CpFormItem>
              <CpFormItem>
                <CpLabel name={`ngs.payload`}>Payload</CpLabel>
                <CpDescription>Max message payload</CpDescription>
                <CpInputNumber name={`ngs.payload`} addonAfter={`bytes`} />
                <CpErrorWarning name={`ngs.payload`} />
              </CpFormItem>
            </CardCollapsibleContent>
          </CardContent>
        </Card>
      </div>
    </>
  );
};
